module.exports = __webpack_public_path__ + "ui-static/img/no-items_light.270ca6c0.svg";